import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import CustomersMain from "./CustomersMain";

const Customers: React.FC = () => {
  return (
    <div className="orders">
      <Sidebar activeTab="customers" />
      <CustomersMain />
    </div>
  );
};

export default Customers;
